import * as Icons from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { VERIFICATION_STEPS } from "@/data/content";

export const HowItWorks = () => {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal><Overline>How Verification Works</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 text-4xl sm:text-5xl font-semibold font-heading tracking-tight leading-tight text-slate-900">
              A structured path from application to verified.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
              Every manufacturer moves through the same six-stage review before becoming part of your sourcing network.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 relative max-w-3xl mx-auto">
          <div className="absolute left-[27px] sm:left-[31px] top-4 bottom-4 w-px bg-gradient-to-b from-slate-200 via-slate-200 to-blue-200" />
          <div className="space-y-5">
            {VERIFICATION_STEPS.map((s, i) => {
              const Icon = Icons[s.icon] || Icons.Circle;
              const isLast = i === VERIFICATION_STEPS.length - 1;
              return (
                <Reveal key={s.step} delay={i * 0.06}>
                  <div data-testid={`verification-step-${i}`} className="relative flex gap-5 sm:gap-6 items-start">
                    <span className={`relative z-10 flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-2xl shrink-0 border transition-colors ${isLast ? "bg-emerald-600 text-white border-emerald-600 shadow-[0_10px_25px_rgba(16,185,129,0.3)]" : "bg-white text-blue-600 border-slate-200 shadow-[0_2px_10px_rgba(15,23,42,0.05)]"}`}>
                      <Icon className="w-6 h-6" />
                    </span>
                    <div className="flex-1 rounded-2xl border border-slate-200/80 bg-white p-5 sm:p-6 transition-all duration-300 hover:shadow-[0_16px_36px_rgba(15,23,42,0.07)] hover:-translate-y-0.5">
                      <div className="flex items-center gap-3">
                        <span className="text-xs font-mono font-semibold text-slate-400">{s.step}</span>
                        <h3 className="text-lg font-semibold text-slate-900">{s.title}</h3>
                      </div>
                      <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{s.description}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
